import type {QueryKey} from '@github-ui/react-query'
import {useState} from 'react'

import styles from './ProjectItemSection.module.css'
import {ProjectItemSectionFieldList} from './ProjectItemSectionFieldList'
import type {ProjectItemSectionViewFragment} from './ProjectItemSectionView'
import {ProjectItemSectionView} from './ProjectItemSectionView'

export type ProjectItemSectionProps = {
  projectItem: ProjectItemSectionViewFragment
  isPending: boolean
  isOpen: boolean
  onIssueUpdate: () => void
  isProjectClosed: boolean
  owner: string
  repo: string
  issueNumber: number
  fieldValueQueryKey?: QueryKey
}

export function ProjectItemSection({
  projectItem: data,
  isPending,
  onIssueUpdate,
  isOpen = false,
  isProjectClosed,
  owner,
  repo,
  issueNumber,
  fieldValueQueryKey,
}: ProjectItemSectionProps) {
  const [open, setOpen] = useState(isOpen)

  return (
    <div className={styles.ProjectItemSectionContainer}>
      <ProjectItemSectionView
        projectItem={data}
        isPending={isPending}
        open={open}
        setOpen={setOpen}
        onIssueUpdate={onIssueUpdate}
        isSelectedProject={isOpen}
        isProjectClosed={isProjectClosed}
        owner={owner}
        repo={repo}
        issueNumber={issueNumber}
        fieldValueQueryKey={fieldValueQueryKey}
      />
      {open && !isPending && (
        <ProjectItemSectionFieldList
          projectItemId={data.id}
          owner={owner}
          repo={repo}
          issueNumber={issueNumber}
          onIssueUpdate={onIssueUpdate}
        />
      )}
    </div>
  )
}
